import { useState, useEffect } from "react";

const storeKeys = {
  token: "token",
  idToken: "id-token",
  propertyId: "propertyId",
  user: "user",
  colorTheme: "color-theme",
  themeId: "theme-id",
  selectedDevice: "selected-device",
  credentials: "credentials",
  doc: "device-doc",
  smartTheme: "smart-theme",
  haptic: "haptic",
  PN: "PN",
  homeVoltage: "home-voltage",
  property: "property",
  selectedHouse: "selected-house",
  devices: "devices",
  hikToken: "hik-token",
  fcmToken: "fcmToken",
  acTemperature: "acTemperature",
  analyticsStatus: "analyticsStatus",
  floor: "floorrmkey",
  lastRoom: "floorLastRoom",
  deviceConfig: "deviceConfigKey",
  offlineStatus: "offlineStatus",
  wifiCredenToken: "wifiCredenToken",
  accountCredenToken: "accountCredenToken",
  saveAllWifiNetToken: "saveAllWifiNetToken",
  bendingDeviceToken: "bendingDeviceToken",
  soundStateLocal: "soundStateLocal",
  environmentToken: "environmentToken",
};

//   const [localToken, setLocalToken] = useState();

const Keycloaktokens = {
  setToken(token) {
    localStorage.setItem(storeKeys.token, token);
  },
  getToken() {
    const items = localStorage.getItem(storeKeys.token);
    if (items) {
      return items ? items : null;
    }
  },
  removeToken() {
    localStorage.removeItem(storeKeys.token);
    localStorage.removeItem(storeKeys.idToken);
  },
  // The ID token, kept only to end the login server's session on logout.
  setIdToken(token) {
    if (token) localStorage.setItem(storeKeys.idToken, token);
  },
  getIdToken() {
    return localStorage.getItem(storeKeys.idToken);
  },
};

const User = {
  setPropertyId(PropertyId) {
    localStorage.setItem(storeKeys.propertyId, PropertyId);
  },
  getPropertyId() {
    const items = localStorage.getItem(storeKeys.propertyId);
    // console.log('getPropertyId', items);
    if (items) {
      return items;
    }else{
      return null;
    }
  },
  removePropertyId() {
    localStorage.removeItem(storeKeys.propertyId);
  },
  setUser(username) {
    localStorage.setItem(storeKeys.user, username);
  },
  getUser() {
    const items = localStorage.getItem(storeKeys.user);
    if (items) {
      return items ? items : null;
    }
  },
  removeUser() {
    localStorage.removeItem(storeKeys.user);
  },
  getColorTheme() {
    const theme = localStorage.get(storeKeys.colorTheme);
    return theme ? theme : null;
  },
  async setFcmToken(token) {
    localStorage.setItem(storeKeys.fcmToken, token);
  },
  async getFcmToken() {
    const token = localStorage.getItem(storeKeys.fcmToken);
    return token ? token : null;
  },
  async clearFcmToken() {
    localStorage.removeItem(storeKeys.fcmToken);
  },
};

const Settings = {
  // Whether push notifications are on in this browser: true, false, or null
  // before it has been set.
  getPNEnabled() {
    const value = localStorage.getItem(storeKeys.PN);
    return value === null ? null : value === "true";
  },
  setPNEnabled(enabled) {
    localStorage.setItem(storeKeys.PN, String(Boolean(enabled)));
  },
  // The rest of the app's Settings screen, kept in this browser like the app
  // keeps them on the phone. Switches are off until turned on, as in the app.
  getThemeId() {
    return localStorage.getItem(storeKeys.themeId) ?? "2";
  },
  setThemeId(themeId) {
    localStorage.setItem(storeKeys.themeId, themeId);
  },
  getHaptic() {
    return localStorage.getItem(storeKeys.haptic) === "true";
  },
  setHaptic(enabled) {
    localStorage.setItem(storeKeys.haptic, String(Boolean(enabled)));
  },
  getSound() {
    return localStorage.getItem(storeKeys.soundStateLocal) === "true";
  },
  setSound(enabled) {
    localStorage.setItem(storeKeys.soundStateLocal, String(Boolean(enabled)));
  },
  getAnalytics() {
    return localStorage.getItem(storeKeys.analyticsStatus) === "true";
  },
  setAnalytics(enabled) {
    localStorage.setItem(storeKeys.analyticsStatus, String(Boolean(enabled)));
  },
  getHomeVoltage() {
    return localStorage.getItem(storeKeys.homeVoltage) ?? "230";
  },
  setHomeVoltage(voltage) {
    localStorage.setItem(storeKeys.homeVoltage, voltage);
  },
};

const Device = {};

const Remote = {};

const Floor = {};
export { Keycloaktokens, User, Settings, Device, Remote, Floor };
